/* global Swiper */
import helpers from '../util/helpers';
import * as constants from '../util/constants';
import moment from 'moment';

const redirectToSynxis = ({
  hotelCode,
  startDate,
  endDate,
  numGuests,
  dateFormat,
}) => {
  const { BookingWidget } = window;

  if (!BookingWidget) {
    return false;
  }

  const {
    DEFAULT_DATE_FORMAT,
    SYNXIS_CONSTANTS: {
      SYNXIS_URL,
      SYNXIS_DATE_DEFAULT_JS_FORMAT,
      SYNXIS_BRAND_CODES,
    },
  } = BookingWidget.constants;

  const hotelKey = Object.keys(BookingWidget['mappedLocations']).find((key) => {
    const location = BookingWidget['mappedLocations'][key];
    return location.isHotel && location.hotelCode === hotelCode;
  });

  if (!hotelKey) {
    return false;
  }

  const hotelData = BookingWidget['mappedLocations'][hotelKey];
  const synxisSettings = hotelData['synxisSettings'];
  const brand = hotelData['brand'];
  const ratesApiSource = hotelData['ratesApiSource'];

  if (!synxisSettings) {
    return false;
  }

  const synxisBrandCode = SYNXIS_BRAND_CODES[brand];

  if (!synxisBrandCode) {
    return false;
  }

  if (ratesApiSource !== 'ireckonu_api') {
    return false;
  }

  if (
    !synxisSettings.enableSynxisHotel
    || !synxisSettings.synxisChainId
  ) {
    return false;
  }

  const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

  const arriveMoment = moment(startDate, bookingDateFormat);
  let arrive = startDate;

  if (arriveMoment.isValid()) {
    arrive = arriveMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
  }

  const departMoment = moment(endDate, bookingDateFormat);
  let depart = endDate;

  if (departMoment.isValid()) {
    depart = departMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
  }

  const adultsCounts = [];
  const childrenCounts = [];

  numGuests.forEach((guest) => {
    const {
      numAdults,
      numChildren,
    } = guest;

    adultsCounts.push(isNaN(numAdults)? 0 : numAdults);
    childrenCounts.push(isNaN(numChildren)? 0 : numChildren);
  });

  const adult = adultsCounts.join(',');
  const child = childrenCounts.join(',');

  const rooms = numGuests.length;

  const params = {
    Hotel: synxisSettings.synxisHotelId,
    Chain: synxisSettings.synxisChainId,
    theme: synxisBrandCode,
    config: synxisBrandCode,
    arrive,
    depart,
    rooms,
    adult,
    child,
  };

  const qsParams = Object.keys(params).map((key) => {
    const value = params[key];

    if (!value) {
      return null;
    }

    return `${key}=${value}`;
  }).filter((param) => !!param).join('&');

  window.open(`${SYNXIS_URL}/?${qsParams}`, '_blank');

  return true;
};

export default{
  init() {
    // Hero
    const hotelHomepageHero = $('.hotel-homepage-hero');
    if (hotelHomepageHero.length) {
      const swiperContainer = hotelHomepageHero.find('.swiper-container').get(0);

      if (swiperContainer) {
        const autoplaySpeed = $(swiperContainer).data('autoplay-speed');
        let autoplay = false;

        if (autoplaySpeed) {
          autoplay = {
            delay: autoplaySpeed,
          };
        }

        new Swiper(swiperContainer, {
          autoplay,
          loop: true,
          effect: 'fade',
          slidesPerView: 1,
          fadeEffect: {
            crossFade: true,
          },
        });
      }
    }

    // TODO: update key feature preview image when slide changes? (to confirm)
    // Hero Booking form
    const heroBookingForm = $('form.hero-booking-form');
    if (heroBookingForm.length) {
      $(document).on('submit', 'form.hero-booking-form', function(e) {
        const _this = $(this);

        let hotelCode = _this.find('.hotel-select').val();
        if (!hotelCode) {
          hotelCode = _this.find('[name="hotelCode"]').val();
        }

        const startDate = _this.find('[name="startDate"]').val();
        const endDate = _this.find('[name="endDate"]').val();
        const dateFormat = _this.find('[name="dateJsFormat"]').val();
        const numGuests = [{
          numAdults: 2,
          numChildren: 0,
        }];

        if (
          hotelCode &&
          startDate &&
          endDate &&
          redirectToSynxis({
            hotelCode,
            startDate,
            endDate,
            numGuests,
            dateFormat,
          })
        ) {
          e.preventDefault();
        }
      });

      heroBookingForm.each(function() {
        const _this = $(this);

        const hotelSelect = _this.find('.hotel-select');
        const daterangePicker = _this.find('.daterange-picker-home-hero-input');
        const startDate = _this.find('[name="startDate"]');
        const endDate = _this.find('[name="endDate"]');

        if (hotelSelect.length) {
          hotelSelect.on('change', function() {
            const hotelCode = hotelSelect.val();
            const dataDatePicker = _this.find('.daterange-picker-home-hero-input').data('daterangepicker');

            const keys = Object.keys(Ode['mappedLocations']).filter(function(key) {
              const obj = Ode['mappedLocations'][key];
              return (('isHotel' in obj) && obj.isHotel && ('hotelCode' in obj) && obj.hotelCode.toUpperCase() === hotelCode.toUpperCase());
            });

            if (keys.length) {
              const key = keys.pop();

              const location = Ode['mappedLocations'][key];
              let minDate = new Date();

              if (('allowBookingFrom' in location) && location['allowBookingFrom']) {
                minDate = new Date(location['allowBookingFrom']);
              }

              if (moment(minDate).isSameOrAfter(moment(), 'day')) {
                dataDatePicker.startDate = dataDatePicker.minDate = moment(minDate);
                dataDatePicker.endDate = moment(dataDatePicker.startDate).add(1, 'day').endOf('day');

                const start = dataDatePicker.startDate.format(constants.DATE_FORMAT_AUS);
                const end = dataDatePicker.endDate.format(constants.DATE_FORMAT_AUS);

                dataDatePicker.updateView();
                daterangePicker.text(start + ' - ' + end);

                if (daterangePicker.hasClass('deeplink-rates')) {
                  startDate.val(dataDatePicker.startDate.format(constants.DATE_FORMAT_AUS));
                  endDate.val(dataDatePicker.endDate.format(constants.DATE_FORMAT_AUS));
                } else {
                  startDate.val(dataDatePicker.startDate.format(constants.DATE_FORMAT_ISO));
                  endDate.val(dataDatePicker.endDate.format(constants.DATE_FORMAT_ISO));
                }
              }
            }
          });
        }
      });
    }

    // Hero daterangepicker
    const daterangePickerHomeHero = $('.daterange-picker-home-hero-input');
    if (daterangePickerHomeHero.length) {
      daterangePickerHomeHero.each(function() {
        const _this = $(this);

        const drpMinDate = _this.data('drp-min');
        const drpMaxDate = _this.data('drp-max');
        const drpStartDate = _this.data('drp-start-date') ? _this.data('drp-start-date') : false;
        const drpEndDate = _this.data('drp-end-date') ? _this.data('drp-end-date') : false;
        const drpRestrictDays = _this.data('drp-restrict-days');
        const drpMinNights = _this.data('drp-min-nights') ? parseInt(_this.data('drp-min-nights')) : 1;

        const defaultText = _this.text();
        let openSide = (helpers.isMobile() || $(window).width() < 992) ? 'center' : 'left';
        let dropSide = _this.data('drp-drop-side') ? _this.data('drp-drop-side') : 'up';

        _this.daterangepicker({
          minDate: drpMinDate ? drpMinDate : moment(),
          maxDate: drpMaxDate ? drpMaxDate : moment().add(13, 'months'),
          startDate: drpStartDate,
          endDate: drpEndDate,
          restrictWeekDays: drpRestrictDays ? drpRestrictDays : 0,
          autoUpdateInput: false,
          autoApply: true,
          opens: openSide,
          drops: dropSide,
          dateLimitMin: drpMinNights,
          parentEl: 'body',
          calendarClasses: 'daterange-hero-calendar dark',
          locale: {
            cancelLabel: 'Clear',
          },
        });

        _this.on('click', function(evt) {
          let picker = $(this).data('daterangepicker');

          // Smoothscroll to picker down
          if (dropSide == 'down') {
            const scrollOffset = -Math.abs(window.innerHeight - 450);
            $(this).goToElement(undefined, scrollOffset);
          }

          if (!picker.isShowing || defaultText.toLowerCase() === $(this).text().toLowerCase()) {
            return;
          }

          let x = evt.pageX - $(this).offset().left;
          let xPercent = (x / $(this).outerWidth()) * 100;

          if (xPercent > 50 && !picker.singleDatePicker) {
            picker.unsetEndDate();
          }
        });

        _this.on('apply.daterangepicker', function(ev, picker) {
          const start = picker.startDate.format(constants.DATE_FORMAT_AUS);
          const end = picker.endDate.format(constants.DATE_FORMAT_AUS);

          _this.text(start + ' - ' + end);

          const hiddenCheckin = _this.closest('form').find('input[name="startDate"]');
          const hiddenCheckout = _this.closest('form').find('input[name="endDate"]');

          if (_this.hasClass('deeplink-rates')) {
            hiddenCheckin.val(picker.startDate.format(constants.DATE_FORMAT_AUS));
            hiddenCheckout.val(picker.endDate.format(constants.DATE_FORMAT_AUS));
          } else {
            hiddenCheckin.val(picker.startDate.format(constants.DATE_FORMAT_ISO));
            hiddenCheckout.val(picker.endDate.format(constants.DATE_FORMAT_ISO));
          }
        });

        _this.on('cancel.daterangepicker', function() {
          _this.text('Select Dates');

          const hiddenCheckin = _this.closest('form').find('input[name="startDate"]');
          const hiddenCheckout = _this.closest('form').find('input[name="endDate"]');

          hiddenCheckin.attr('value', '');
          hiddenCheckout.attr('value', '');
        });
      });
    }
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelHomepage.js